module.exports = "https://static.energy5.com/_next/static/images/percent100k-19d51110d3d5a624624a992ac907af44.png";